<div class="page-content">
  <div class="row">
    <div class="header-options col-12">
      <div class="gai-case">
        <div class="back-content">
          <mat-icon (click)="back()">arrow_back_ios</mat-icon>
        </div>
        <div class="title">
          <h3>Alerta {{ alert?.gai }}</h3>
        </div>
      </div>
      <mat-icon class="edit" [matMenuTriggerFor]="menu"> more_horiz </mat-icon>
      <mat-menu #menu="matMenu">
        <!-- <button *ngIf="canRequest" mat-menu-item (click)="requestApproval()">
          Solicitar Revisión
        </button> -->

        <!-- <ng-container *ngIf="needApproval">
        <button mat-menu-item (click)="approval()">Aprobar</button>
        <button mat-menu-item (click)="reject()">Rechazar</button>
      </ng-container> -->

        <!-- <button mat-menu-item *ngIf="canAddTask" (click)="addTasks()">
        <span>Agregar tareas</span>
      </button> -->
        <!-- <button
        mat-menu-item
        (click)="edit()"
        *ngIf="canEdit && case?.status != 'toFinalize'"
      >
        <span>Editar</span>
      </button> -->
        <button *ngIf="cantipifi" mat-menu-item (click)="proceedCase()">
          <span>Tipificar</span>
        </button>
      </mat-menu>
    </div>
    <div class="col-12">
      <mat-tab-group class="mgTop" mat-align-tabs="start">
        <mat-tab label="Datos cliente">
          <div class="row margin0">
            <div class="col-6">
              <div class="divData" *ngIf="alert?.tipo_de_persona">
                <p class="dataTitle">Tipo de persona</p>
                <p class="dataInfo">
                  {{ alert?.tipo_de_persona }}
                </p>
              </div>
              <div class="divData" *ngIf="alert?.apellido">
                <p class="dataTitle">Apellidos</p>
                <p class="dataInfo">{{ alert?.apellido }}</p>
              </div>
              <div class="divData" *ngIf="alert?.oficina">
                <p class="dataTitle">Oficina/Agencia</p>
                <p class="dataInfo">
                  {{ alert?.oficina }}
                </p>
              </div>
              <div class="divData" *ngIf="alert?.telefono">
                <p class="dataTitle">Teléfono de contacto</p>
                <p class="dataInfo">
                  {{ alert?.telefono }}
                </p>
              </div>
              <div class="divData" *ngIf="alert?.celular">
                <p class="dataTitle">Celular</p>
                <p class="dataInfo">
                  {{ alert?.celular }}
                </p>
              </div>
              <div class="col-12 divData" *ngIf="alert?.domicilio">
                <p class="dataTitle">Domicilio del cliente</p>
                <p class="dataInfo">
                  {{ alert?.domicilio }}
                </p>
              </div>
            </div>
            <div class="col-6">
              <div class="divData" *ngIf="alert?.numero_de_identificacion">
                <p class="dataTitle">CI/RIF</p>
                <p class="dataInfo">
                  {{ alert?.numero_de_identificacion }}
                </p>
              </div>
              <div class="divData" *ngIf="alert?.nombre">
                <p class="dataTitle">Nombre de la persona</p>
                <p class="dataInfo">{{ alert?.nombre }}</p>
              </div>
              <div class="divData" *ngIf="alert?.region">
                <p class="dataTitle">Región</p>
                <p class="dataInfo">
                  {{ alert?.region }}
                </p>
              </div>
              <div class="divData" *ngIf="alert?.correo">
                <p class="dataTitle">Email</p>
                <p class="dataInfo">
                  {{ alert?.correo }}
                </p>
              </div>
              <div class="divData" *ngIf="alert?.cliente">
                <p class="dataTitle">ID Cliente</p>
                <p class="dataInfo">
                  {{ alert?.cliente }}
                </p>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Datos de Alerta"
          ><div class="row margin0">
            <div class="col-6">
              <div class="divData" *ngIf="alert?.gai">
                <p class="dataTitle">Número del caso</p>
                <p class="dataInfo">
                  {{ alert?.gai }}
                </p>
              </div>
              <div class="divData" *ngIf="alert?.tipo_registro">
                <p class="dataTitle">Tipo de registro</p>
                <p class="dataInfo">
                  {{ alert?.tipo_registro }}
                </p>
              </div>
              <div class="divData" *ngIf="alert?.oficina">
                <p class="dataTitle">Descripción del caso</p>
                <p class="dataInfo">
                  {{ alert?.oficina }}
                </p>
              </div>
              <div class="divData" *ngIf="alert?.instrumento">
                <p class="dataTitle">Datos del instrumento financiero</p>
                <p class="dataInfo">
                  {{ alert?.instrumento }}
                </p>
              </div>
              <div class="divData" *ngIf="alert?.idCreator">
                <p class="dataTitle">ID Gerente Responsable</p>
                <p class="dataInfo">
                  {{ alert?.idCreator ? alert.idCreator : "Sin id" }}
                </p>
              </div>
              <div class="divData" *ngIf="alert?.referenceTransaction">
                <p class="dataTitle">ID Gerente Responsable</p>
                <p class="dataInfo">
                  {{
                    alert?.referenceTransaction
                      ? alert.referenceTransaction
                      : "Sin Referencia"
                  }}
                </p>
              </div>
            </div>
            <div class="col-6">
              <div class="divData" *ngIf="alert?.status">
                <p class="dataTitle">Estado del caso</p>
                <p class="dataInfo">
                  {{ status[alert?.status] }}
                </p>
              </div>
              <div *ngIf="alert?.status == 'refused'" class="divData">
                <p class="dataTitle">Motivo rechazo</p>
                <p class="dataInfo">
                  {{ alert?.reason }}
                </p>
              </div>
              <div class="divData" *ngIf="alert?.dateEvent">
                <p class="dataTitle">Fecha de creación</p>
                <p class="dataInfo">
                  {{ alert?.dateEvent | date : "d/M/yy, h:mm:ss a" }}
                </p>
              </div>
              <div class="divData" *ngIf="alert?.canal">
                <p class="dataTitle">Canal</p>
                <p class="dataInfo">
                  {{ alert?.canal }}
                </p>
              </div>
              <div class="divData" *ngIf="alert?.userTipify?.fullname || alert?.creator?.fullname">
                <p class="dataTitle">Gerente responsable</p>
                <p class="dataInfo">{{ alert?.userTipify?.fullname || alert?.creator?.fullname }}</p>
              </div>
              <div class="divData" *ngIf="alert?.monto_salio">
                <p class="dataTitle">Monto ha salido de la cuenta</p>
                <p class="dataInfo">{{ alert?.monto_salio }}</p>
              </div>
              <div class="divData" *ngIf="alert?.numberIdInstrumnet">
                <p class="dataTitle">Número instrumento</p>
                <p class="dataInfo">
                  {{
                    alert?.numberIdInstrumnet
                      ? alert?.numberIdInstrumnet
                      : "Sin instrumento de Instrumento"
                  }}
                </p>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Dato tipificado">
          <div class="row margin0">
            <div class="col-6">
              <div class="divData" *ngIf="alert?.type">
                <p class="dataTitle">Tipo</p>
                <p class="dataInfo">
                  {{ alert?.type }}
                </p>
              </div>
              <div class="divData" *ngIf="alert?.subType">
                <p class="dataTitle">SubTipo</p>
                <p class="dataInfo">
                  {{ alert?.subType }}
                </p>
              </div>
              <div class="divData">
                <p class="dataTitle">Analista responsable</p>
                <p class="dataInfo">
                  {{
                    alert?.assigned ? alert?.assigned.fullname : "Sin asignar"
                  }}
                </p>
              </div>
            </div>
            <div class="col-6">
              <div class="divData" *ngIf="alert?.category">
                <p class="dataTitle">Categoría</p>
                <p class="dataInfo">
                  {{ alert?.category }}
                </p>
              </div>
              <div *ngIf="alert?.case" class="divData">
                <p class="dataTitle">Caso asociado</p>
                <p class="dataInfo">
                  {{ alert?.case.gai }}
                </p>
              </div>
              <div *ngIf="alert?.assigned || alert?.reason" class="divData">
                <p class="dataTitle">Decisión</p>
                <p class="dataInfo">
                  {{ desition[alert?.status] }}
                  <!-- //CAMBIA ESTO -->
                </p>
              </div>
              <div
                *ngIf="alert?.reason && alert?.status == 'refused'"
                class="divData"
              >
                <p class="dataTitle">Razón del rechazo</p>
                <p class="dataInfo">
                  {{ alert?.reason }}
                </p>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
<alert-record [view]="showMore" (hidden)="showMore = false"></alert-record>
